<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 107.569 108.71"
    :aria-labelledby="iconName"
    role="presentation"
  >
  <g id="Group_3420" data-name="Group 3420" transform="translate(-1660.431 -268.191)">
    <g id="Group_3419" data-name="Group 3419" transform="translate(1660.431 268.191)">
      <path :fill="iconColor" id="Path_4326" data-name="Path 4326" d="M498.652,362.017H444.144a9.654,9.654,0,0,0-9.644,9.644v80.481a9.757,9.757,0,0,0,6.6,9.178l31.1,8.961a9.925,9.925,0,0,0,2.979.447,9.654,9.654,0,0,0,9.644-9.644v-3.77h13.829a13.012,13.012,0,0,0,13-13v-69.3A13.011,13.011,0,0,0,498.652,362.017ZM503.54,431.6v12.711a4.894,4.894,0,0,1-4.888,4.888H484.822V380.6a9.755,9.755,0,0,0-6.6-9.178l-4.507-1.3h24.932a4.894,4.894,0,0,1,4.888,4.887V431.6Zm-60.931-59.944a1.536,1.536,0,0,1,1.535-1.535,1.789,1.789,0,0,1,.534.07l30.954,8.914a1.611,1.611,0,0,1,1.081,1.492v80.481a1.535,1.535,0,0,1-1.535,1.533,1.783,1.783,0,0,1-.534-.07l-30.954-8.913a1.615,1.615,0,0,1-1.081-1.492Z" transform="translate(-434.5 -362.017)"/>
      <circle :fill="iconColor" id="Ellipse_184" data-name="Ellipse 184" cx="4.208" cy="4.208" r="4.208" transform="translate(30.158 50.474)"/>
    </g>
  </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
